module.exports = __webpack_public_path__ + "static/media/12B.b0b80e56.png";